import GravityForms from './components/GravityForms';
import MainHeader from './components/MainHeader';
import SiteDropdownMenu from './components/SiteDropdownMenu';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resize);
		window.addEventListener('load', this.load);

		const focusableElements = document.querySelectorAll(
			'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
		);

		focusableElements.forEach((el) => {
			el.addEventListener('focus', this.focus);
		});
	}

	init() {
		MainHeader.init();
		GravityForms.init();
		SiteDropdownMenu.init();
	}

	resize() {
		MainHeader.resize();
	}

	load() {
		MainHeader.load();
	}

	focus(e) {
		MainHeader.focus(e);
	}
}

// Run controller.
new Controller();
